import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import BlendForm from "../components/Form";
import {
  getOneBlend,
  resetUpdateOneBlend,
  updateBlend,
} from "../../../redux/slices/blend";
import convertToNumber from "../../../helpers/convertToNumber";
import AlertComponent from "../../../components/alerts/Alert";

const keys = {
  pigin_name: "",
  chinese_name: "",
  latin_name: "",
  english_name: "",
  therapeutic_actions: "",
  administration: "",
  clinical_manifestations: "",
  treats_conditions: "",
  syndroms: [],
  contraindications: "",
  herbs_drugs_interactions: "",
  herb: [],
  tongue: {
    color: "",
    shape: "",
    coating: "",
    veins: "",
  },
  pulse: {
    kidney: "",
    spleen: "",
    lung: "",
    liver: "",
  },
};

const Component = ({
  blendUpdate,
  blendUpdateLoading,
  blendUpdateError,
  blendUpdateSuccess,
  blend,
  blendLoading,
  blendError,
  blendSuccess,
  infoRoute,
}) => {
  // translation
  const { t } = useTranslation();
  // redux
  const dispatch = useDispatch();
  // route
  const {
    history,
    location: {
      state: { id },
    },
  } = infoRoute;
  // utils
  const [initialValues, setInitialValues] = useState(keys);
  const [alert, setAlert] = useState({
    open: false,
    severity: "",
    message: "",
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    // Get all form elements
    var formElements = event.target.elements;

    // Create an object to store form values
    var formData = {};

    // Iterate over form elements and populate formData object
    for (var i = 0; i < formElements.length; i++) {
      var element = formElements[i];

      // Check if the element name is not empty
      if (element.name) {
        let value = element.value;

        // Check if the name includes "herb"
        if (
          element.name.includes("herb") &&
          element.name !== "herbs_drugs_interactions"
        ) {
          // Extract the index and attribute from the element name
          var matches = element.name.match(/herb\.(\d+)\.([a-z]+)/);

          if (matches) {
            var index = parseInt(matches[1]);
            var attribute = matches[2];

            // Ensure the formData has enough elements for the "herb" array
            formData["herb"] = formData["herb"] || [];

            // Ensure the "herb" array has enough elements
            formData["herb"][index] = formData["herb"][index] || {};

            // Assign value to the corresponding element in the formData
            formData["herb"][index][attribute] = convertToNumber(value);
          }
        } else if (element.name.includes("syndroms")) {
          // Extract the index and attribute from the element name
          var matches = element.name.match(/syndroms\.(\d+)/);

          if (matches) {
            var index = parseInt(matches[1]);

            // Ensure the formData has enough elements for the "herb" array
            formData["syndroms"] = formData["syndroms"] || [];

            // Ensure the "herb" array has enough elements
            formData["syndroms"][index] = formData["syndroms"][index] || {};

            // Assign value to the corresponding element in the formData
            formData["syndroms"][index] = convertToNumber(value);
          }
        } else if (element.name.includes("private")) {
          formData["private"] = !value || value === "true";
        } else {
          // Split the name into nested keys using dot notation
          const keys = element.name.split(".");
          let tempObj = formData;

          // Build the nested structure
          for (let j = 0; j < keys.length - 1; j++) {
            const key = keys[j];
            tempObj[key] = tempObj[key] || {};
            tempObj = tempObj[key];
          }

          // Assign the value to the final nested key
          tempObj[keys[keys.length - 1]] = convertToNumber(value);
        }
      }
    }

    console.log("Update blend submit payload", formData);
    dispatch(updateBlend({ id: blend.id, ...formData }));
  };

  useEffect(() => {
    let initialValues = {};
    if (!!blend) {
      for (const key of Object.keys(keys)) {
        initialValues[key] = blend[key];
      }
    }

    setInitialValues(initialValues);
  }, [blend]);

  useEffect(() => {
    if (id) {
      dispatch(getOneBlend({ id }));
    }
  }, [infoRoute]);

  useEffect(() => {
    if (blendUpdateError) {
      setAlert({
        open: true,
        severity: "error",
        message: t("Messages.The operation could not be processed"),
      });
    }
  }, [blendUpdateError]);

  useEffect(() => {
    if (blendUpdateSuccess) {
      setAlert({
        open: true,
        severity: "success",
        message: t("Messages.The operation was successful"),
      });
      setTimeout(() => {
        history.push("/blend");
      }, 1000);
    }
  }, [blendUpdateSuccess]);

  useEffect(() => {
    if (blendUpdateError || blendUpdateSuccess) {
      setTimeout(() => {
        dispatch(resetUpdateOneBlend());
        setAlert({
          open: false,
          severity: "",
          message: "",
        });
      }, 3000);
    }
  }, [blendUpdateError, blendUpdateSuccess]);

  return (
    <>
      <div>
        <h4 className="main-title mt-2">{t("BlendEdit.Edit Blend")}</h4>
        <p className="blue-anchors">
          <Link className="blue-anchors" to="/blend">
            &#60; {t("BlendEdit.Back to blends")}
          </Link>
        </p>
      </div>
      <div
        className="d-flex justify-content-end align-items-center"
        style={{ width: "95%", paddingRight: "5%" }}
      >
        {t("BlendEdit.Do you want to create a prescription from this blend?")}
        <Link
          className="blue-anchors"
          to={`/prescription/new?blend_id=${id}`}
          style={{ marginLeft: "8px" }}
        >
          {t("BlendEdit.click here")}
        </Link>
      </div>
      <Form
        noValidate
        id="edit-blend-form"
        onSubmit={handleSubmit}
        style={{ width: "95%" }}
      >
        <BlendForm
          initialValues={initialValues}
          isLoading={blendUpdateLoading || blendLoading}
        />
        <div className="d-flex justify-content-end">
          <Button
            className="btnGo"
            form="edit-blend-form"
            type="submit"
            target={false}
            disabled={blendUpdateLoading}
          >
            {t("BlendEdit.Edit Blend")}
          </Button>
        </div>
      </Form>

      <AlertComponent
        isAlert={alert.open}
        setIsAlert={setAlert}
        severity={alert.severity}
        message={alert.message}
      />
    </>
  );
};

const state = ({ blendStore }) => {
  const {
    data: blend,
    loading: blendLoading,
    error: blendError,
    success: blendSuccess,
  } = blendStore.one;

  const {
    data: blendUpdate,
    loading: blendUpdateLoading,
    error: blendUpdateError,
    success: blendUpdateSuccess,
  } = blendStore.update;

  return {
    blendUpdate,
    blendUpdateLoading,
    blendUpdateError,
    blendUpdateSuccess,
    blend,
    blendLoading,
    blendError,
    blendSuccess,
  };
};

export default connect(state)(Component);
